<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
             <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getListHandler" clearable></el-input>
            </el-form-item>
             <el-form-item label="套餐状态："> 
                <el-select v-model="searchForm.timeState" clearable>
                    <el-option label="已过期" value="1"></el-option>
                    <el-option label="生效中" value="2"></el-option>
                    <el-option label="未生效" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐列表：">
                <el-select v-model="searchForm.packageId" placeholder="请选择" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.code" :key="item.code" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
              <el-form-item label="过期时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary"  plain icon="el-icon-search" @click="getListHandler($event)" >查 询</el-button>
                 <el-button type="success" plain @click="confirmExportDialogVisible = true"  icon="el-icon-download">导出Excel</el-button>
            </el-form-item>
        </el-form>


        <el-table :data="tbpg.tableData"
		 border
		 fit
		 highlight-current-row
		 style="width: 100%;"
		 :header-cell-style="{background:'#f5f5f5'}"
		 :default-sort = "{prop: 'createTime', order: 'descending'}">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column label="ICCID号" width="180px" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="userPhone" label="用户手机号" width="120" align="center"></el-table-column>
            <el-table-column prop="packageName" label="套餐名称" width="120" align="center"></el-table-column>
            <el-table-column prop="usedFlowRate" label="套餐使用流量" sortable align="center"></el-table-column>
            <el-table-column prop="usedRealFlowRate" label="使用真实流量"  align="center"></el-table-column>
            <el-table-column prop="flowRatePercent" label="虚量百分比" show-overflow-tooltip align="center"></el-table-column>
             <el-table-column prop="remainData" label="套餐剩余流量"  align="center"></el-table-column>
            <el-table-column prop="startTime" label="套餐生效时间" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="endTime" label="套餐过期时间" show-overflow-tooltip align="center"></el-table-column>

        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 



        <el-dialog :append-to-body="true"  title="批量操作" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
            <el-form ref="limitForm" :model="limitForm"  label-width="100px">
                <el-form-item label="导入Excel：">
                    <el-upload ref="uploadFile" :action="uploadUrl('sim/limit/speed')" :headers="setHeader()" 
                    :auto-upload="false" :on-success="handleSuccess" :data="limitForm" :on-change="handleChange">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=invest')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <!-- <el-form-item label="运营商：" >
                    <el-select v-model="limitForm.supplierCode" placeholder="本系统的卡无需选择运营商" clearable filterable>
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select> 
                </el-form-item> -->
                 <el-form-item label="限速ID" prop="limitSpeed">
                    <el-input v-model="limitForm.limitSpeed" placeholder="请输入限速ID"></el-input>
                </el-form-item>
                <!-- <el-form-item label="限速方式：" prop="limitSpeed">
                    <el-select v-model="limitForm.limitSpeed"  >
                        <el-option v-for="item in statusGroup" :key="item.code" :value="item.code" :label="item.description"></el-option>
                    </el-select> 
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureRechargeHandler">确 定</el-button>
            </div> 
        </el-dialog>


        <el-dialog :append-to-body="true"  title="单卡限速" :visible.sync="singleLimitDialog" width="600px" :close-on-click-modal="false">
            <el-form ref="limitForm" :model="singleLimitForm" label-width="100px">
                <el-form-item label="iccid：" prop="iccid">
                    <el-input v-model="singleLimitForm.iccid" placeholder="请输入iccid"></el-input>
                </el-form-item>
                 <el-form-item label="限速ID" prop="limitSpeed">
                    <el-input v-model="singleLimitForm.limitSpeed" placeholder="请输入限速ID"></el-input>
                </el-form-item>

                <!-- <el-form-item label="限速方式：" prop="limitSpeed">
                    <el-select v-model="singleLimitForm.limitSpeed"  >
                        <el-option v-for="item in statusGroup" :key="item.code" :value="item.code" :label="item.description"></el-option>
                    </el-select> 
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelsSngleLimit()">取 消</el-button>
                <el-button type="primary" @click="singleLimitSpeed()">确 定</el-button>
            </div> 
        </el-dialog>

        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportApplyHandler">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import common from '@/utils/common.js';
export default {
    data(){
        return {
            confirmExportDialogVisible:false,
            searchForm: {
                iccid: '',
                supplierCode: '',
                timeState:'',
                timeMonth:'',
                packageId:'',
                time:''
            },
            branchSupplierOption:[],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            //批量操作
            dialogVisible: false,
            limitForm:{
                supplierCode: null,
                limitSpeed: null,
            },
            statusGroup: [],
            limitFormRules:{
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            },
            //批量操作  end

            //单卡限速操作
            singleLimitDialog: false,
            singleLimitForm:{
                iccid: null,
                limitSpeed: null,
            },
            singleLimitFormRules:{
                iccid:[
                    { required: true, message: '请输入iccid', trigger: 'blur' }
                ],
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
         exportApplyHandler(){
            var data = JSON.parse(JSON.stringify(this.searchForm));
             if(data.time != ''){
                data.startTimeString = data.time[0] + ' 00:00:00'; 
                data.endTimeString = data.time[1] + ' 23:59:59';
            }else{
                data.startTimeString = '';
                data.endTimeString = '';
            }
            delete data.time; 
            this.exportExcel('/mould/download/allPkg', data);
            this.confirmExportDialogVisible = false;
        },

         goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            common.sysRequest('pkg/simUsePkg/listPage', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getListHandler();
        },


        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            
        },
        sureRechargeHandler(){
            if (this.$refs.uploadFile.uploadFiles.length == 0) {
                this.$message.error('请选择文件');
                return;
            }
            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    this.$refs.uploadFile.submit();   
                    this.rechargeVisible = false; 
                } 
            });              
        },

        handleSuccess(res){
            if(res.code == 200){
                this.getListHandler();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.uploadFile.clearFiles();
        },

        cancel(){
            this.limitForm.limitSpeed = null;
            this.limitForm.supplierCode = null;
            this.dialogVisible = false;
        },

        formatLimitSpeed(code){

            let v =  this.statusGroup.filter(function(item){
                if(code == item.code){
                    return item;
                }
            });
            return v[0]&&v[0].description?v[0].description:"";
        },
        

        singleLimitSpeed(){
            let data = new FormData();
            Object.keys(this.singleLimitForm).forEach((key) => {
                data.append(key, this.singleLimitForm[key]);
            });

            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    common.sysRequest("sim/price/limit/speed", data, 'post').then(res=>{
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.getListHandler();
                            this.cancelsSngleLimit();
                        }else{
                            this.$message.error(res.data.message)
                        }     
                    }).catch(err=> console.error(err));
                } 
            });   
            
        },

        cancelsSngleLimit(){
            this.singleLimitForm.limitSpeed = null;
            this.singleLimitForm.iccid = null;
            this.singleLimitDialog = false;
        },
    },

    computed:{
        
    },

    created () {
        this.getListHandler();

        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');

        //获取状态值
        common.sysRequest('pkg/all/pkgType', {}, 'get').then(res => {
            if(res.data.code == 200){
                this.branchSupplierOption = res.data.data;
            }
        })
    },
}
</script>
<style lang="less" scoped>

</style>

